import { Bar, Line } from "react-chartjs-2";
import MenuFrame from "../frames/menu_frame";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';
import { docTypeTransform, getDeskData, getOptions, makeGraph, methodTransform } from "./reports_halper";
import { useState } from "react";
import { Box, Grid } from "@mui/material";
import { ReportNav } from "./nav";

function ReportViewer() {
    const [deskData, setDeskData] = useState(null);
    ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

    const initData = async (auth) => {
        if (!auth) return;
        setDeskData(await getDeskData());
    }

    const makeMonthGraphSale = (data) => {
        if (data === null) return [];
        const label = data.map((itm) => itm.month_year);
        const amount = data.map((itm) => itm.total_amount);
        const pickup = data.map((itm) => itm.pickup_charge);
        const packaging = data.map((itm) => itm.packaging_charge);
        const insurance = data.map((itm) => itm.insurance_charge);
        return makeGraph(label, [amount, pickup, packaging, insurance], ['₹ Sales', 'Pickup', 'Packaging', 'Insurance']);
    }

    const makeWeekGraphSale = (data) => {
        if (data === null) return [];
        const label = data.map((itm) => itm.week_range);
        const amount = data.map((itm) => itm.total_amount);
        const pickup = data.map((itm) => itm.pickup_charge);
        const packaging = data.map((itm) => itm.packaging_charge);
        const insurance = data.map((itm) => itm.insurance_charge);
        return makeGraph(label, [amount, pickup, packaging, insurance], ['₹ Sales', 'Pickup', 'Packaging', 'Insurance']);
    }

    const makeMonthGraphCount = (data) => {
        if (data === null) return [];
        const label = data.map((itm) => itm.month_year);
        const count = data.map((itm) => itm.total_bookings);
        return makeGraph(label, [count], ["Booking Count"]);
    }

    const makeWeekGraphCount = (data) => {
        if (data === null) return [];
        const label = data.map((itm) => itm.week_range);
        const count = data.map((itm) => itm.total_bookings);
        return makeGraph(label, [count], ["Booking Count"]);
    }

    const makeGraphService = (data) => {
        if (data === null) return [];
        data = methodTransform(data);
        return makeGraph(data.span, [data.express, data.surface, data.air, data.premium, data.other], ['Express', 'Surface', 'Air', 'Premium', 'Other']);
    }

    const makeGraphServiceCount = (data) => {
        if (data === null) return [];
        data = methodTransform(data);
        return makeGraph(data.span, [data.count_express, data.count_surface, data.count_air, data.count_premium, data.count_other], ['Express', 'Surface', 'Air', 'Premium', 'Other']);
    }

    const makeGraphQuantity = (data) => {
        if (data === null) return [];
        data = docTypeTransform(data);
        return makeGraph(data.span, [data.document, data.parcel, data.electronic, data.gift, data.other], ['Document', 'Parcel', 'Electronic', 'Gift', 'Other']);
    }

    const makeGraphQuantityCount = (data) => {
        if (data === null) return [];
        data = docTypeTransform(data);
        return makeGraph(data.span, [data.count_document, data.count_parcel, data.count_electronic, data.count_gift, data.count_other], ['Document', 'Parcel', 'Electronic', 'Gift', 'Other']);
    }

    return (
        <MenuFrame permission="ORG_REPORT" screen="ORG_REPORT" onInit={initData}>
            <ReportNav active="day" />

            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 300 }}>
                        <Bar data={makeMonthGraphSale(deskData?.monthly ?? null)} options={getOptions("Desk Sales Rport FY25 - Monthly Revenue")} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 300 }}>
                        <Line data={makeMonthGraphCount(deskData?.monthly ?? null)} options={getOptions("Monthly Booking Count")} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Box sx={{ height: 500 }}>
                        <Bar data={makeWeekGraphSale(deskData?.weekly ?? null)} options={getOptions("Desk Sales Rport FY25 - Weekly Revenue", true)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Box sx={{ height: 500 }}>
                        <Line data={makeWeekGraphCount(deskData?.weekly ?? null)} options={getOptions("Weekly Booking Count", true)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 500 }}>
                        <Bar data={makeGraphService(deskData?.service ?? null)} options={getOptions("Monthly Sales By Method FY25", false, false)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 500 }}>
                        <Line data={makeGraphServiceCount(deskData?.service ?? null)} options={getOptions("Monthly Booking By Method FY25", false, false)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 500 }}>
                        <Bar data={makeGraphQuantity(deskData?.quantity ?? null)} options={getOptions("Monthly Sales By Type FY25", false, false)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ height: 500 }}>
                        <Line data={makeGraphQuantityCount(deskData?.quantity ?? null)} options={getOptions("Monthly Booking By Type FY25", false, false)} />
                    </Box>
                </Grid>
            </Grid>
        </MenuFrame>
    );
}

export default ReportViewer;
